import React, { FC } from 'react';
import { IonTabBar } from '@ionic/react';

export interface AllieTabBarProps {
  children: React.ReactNode;
  slot?: 'top' | 'bottom';
  className?: string;
  style?: React.CSSProperties;
  mode?: 'ios' | 'md';
  translucent?: boolean;
}

/**
 * AllieTabBar - Wrapper around IonTabBar
 * Provides consistent tab bar styling and behavior
 */
export const AllieTabBar: FC<AllieTabBarProps> = ({
  children,
  slot = 'bottom',
  className,
  style,
  mode = 'md',
  translucent = false,
}) => {
  return (
    <IonTabBar
      slot={slot}
      className={className}
      style={style}
      mode={mode}
      translucent={translucent}
    >
      {children}
    </IonTabBar>
  );
};

AllieTabBar.displayName = 'AllieTabBar';
